



















import { Component, Prop, Vue } from 'vue-property-decorator';
import Marker from '@/marker/Marker';
import Category from '@/category/Category';
import LocationPanelMarkerItem from '@/components/location/location-panel/location-panel-item/LocationPanelMarkerItem.vue';

@Component({
    components: { LocationPanelMarkerItem },
})
export default class LocationPanelMobileNavItemBody extends Vue {
    @Prop({ type: Array, required: true })
    markers!: Array<Marker> ;

    @Prop({ type: Category, required: true })
    category!: Category;
}
